class AddressMapper {
    public static readonly toDisplayStreet = (address: OrderTrackerBackend.DeliveryServiceAddress): string =>
        [address.streetName, `${address.streetNr}${address.streetNrSuffix || ''}`].filter(Boolean).join(' ');

    public static readonly toDisplayAddress = (address: OrderTrackerBackend.DeliveryServiceAddress): string =>
        [AddressMapper.toDisplayStreet(address), [address.postCode, address.city].filter(Boolean).join(' ')]
            .filter(Boolean)
            .join(', ');
}

export { AddressMapper };
